export function createSlidesArrayFromJSON(videoSlidesRawFromServer){
    let parsed = JSON.parse(videoSlidesRawFromServer);
    let imagesArray = [];

    for (let i = 0; i < parsed.length; i++) {
        imagesArray.push({
            'boost_shopping_cart_id': parsed[i].boost_shopping_cart_id,
            'sort_order': parsed[i].sort_order,
            'image_source_low_resolution': parsed[i].image_source_low_resolution,
            'image_source_high_resolution': parsed[i].image_source_high_resolution,
            'image_source_trimmed': parsed[i].image_source_trimmed,
            'image_caption': parsed[i].image_caption,
            '$ref': jQuery('.video-slides-modal__captions__selected-photo--js-' + i),
        });
    }

    return imagesArray;
}